<app-header [translation]="myLanguage"></app-header>

<div class="container">
    <a routerLink="/">{{ myLanguage.back }}</a>

    <div class="alert alert-danger mt-2 mb-2" *ngIf="error !== ''">{{error}}</div>

    <article class="mt-4" *ngIf="news !== undefined">
        <h1 class="post-title" style="margin-top: 0">{{ news.headline }}</h1>
        <div class="post-body" [innerHTML]="news.content | safeHtml"></div>


        <aside class="post-footer business-info mb-3" *ngIf="(news.requiredBusinesses && news.requiredBusinesses.length > 0) || (news.careerTitles && news.careerTitles.length > 0)">
            Hinweis: Diese News ist sichtbar mit
            <div *ngIf="news.requiredBusinesses && news.requiredBusinesses.length > 0" class="ms-1">
                Gewerbe <i>{{ renderBusiness(news.requiredBusinesses) }}</i>
            </div>
            <div *ngIf="(news.requiredBusinesses && news.requiredBusinesses.length > 0) && (news.careerTitles && news.careerTitles.length > 0)" class="ms-1">und</div>
            <div *ngIf="news.careerTitles && news.careerTitles.length > 0" class="ms-1">
                Karriere-Position <i>{{ news.careerTitles.join(', ') }}</i>
            </div>

        </aside>

        <aside class="post-footer">
            <span class="time"><span class="ago">{{ myLanguage.updated }} {{ (news.updated | amFromUnix) | amLocale:
                    browserLocale
                    | amTimeAgo }}</span><span class="date">{{ myLanguage.updatedAt }} {{ (news.updated | amFromUnix) |
                    amLocale:
                    browserLocale | amDateFormat:'LL' }}</span></span>
        </aside>

        <aside class="post-footer">
            <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512">
                <path fill="currentColor"
                    d="M256 32c61.8 0 112 50.2 112 112s-50.2 112-112 112-112-50.2-112-112S194.2 32 256 32m128 320c52.9 0 96 43.1 96 96v32H32v-32c0-52.9 43.1-96 96-96 85 0 67.3 16 128 16 60.9 0 42.9-16 128-16M256 0c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144S335.5 0 256 0zm128 320c-92.4 0-71 16-128 16-56.8 0-35.7-16-128-16C57.3 320 0 377.3 0 448v32c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-32c0-70.7-57.3-128-128-128z"
                    class=""></path>
            </svg>
            <span class="author">{{ news.author }}</span>
            <span class="time"><span class="ago">{{ myLanguage.created }} {{ (news.timestamp | amFromUnix) | amLocale:
                    browserLocale
                    | amTimeAgo }}</span><span class="date">{{ myLanguage.createdAt }} {{ (news.timestamp | amFromUnix) |
                    amLocale:
                    browserLocale | amDateFormat:'LL' }}</span></span>
        </aside>
    </article>
</div>

<app-footer [translation]="myLanguage" [userData]="userData"></app-footer>